var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgTopModels = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M6.442 11.333h3.115M8 2v.667m4.243 1.09-.472.472M14 8h-.667M2.667 8H2m2.229-3.771-.472-.472m1.886 6.6a3.333 3.333 0 1 1 4.714 0l-.365.365a2.25 2.25 0 0 0-.659 1.59v.355a1.333 1.333 0 0 1-2.666 0v-.354a2.25 2.25 0 0 0-.659-1.591l-.365-.365Z",
  stroke: "currentColor",
  strokeWidth: 1.333,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})));
export default SvgTopModels;